///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/filter-criteria.ts"/>


module Meevo.Components.Controls.SmartMover {
    import PurchaseOrderStateEnum = Meevo.Model.PurchaseOrderStateEnum;

    export class PurchaseOrdersReceivedItemsFilter extends CriteriaFilter implements ICriteriaFilter {
        public readonly templateName: FilterTemplateNames;
        public readonly values: { displayWithReceivedItems: boolean; displayWithNotReceivedItems: boolean; };
        public readonly criteria: { PurchaseOrderStateEnumList_Tbl: PurchaseOrderStateEnum[] };

        constructor(entities: IApiCollection<any>[], options: IDataTemplateFilterOptions = {}) {
            super(entities, options);

            this.criteria.PurchaseOrderStateEnumList_Tbl = [
                PurchaseOrderStateEnum.PartiallyReceived,
                PurchaseOrderStateEnum.ReceivedInFull,
                PurchaseOrderStateEnum.NotReceived
            ];
            this.templateName = 'purchase-orders';
            this.values = {
                displayWithReceivedItems: true,
                displayWithNotReceivedItems: true
            };
        }

        updateCriteria() {
            const purchaseOrderState: PurchaseOrderStateEnum[] = [];
            if (this.values.displayWithReceivedItems) {
                purchaseOrderState.push(
                    PurchaseOrderStateEnum.PartiallyReceived,
                    PurchaseOrderStateEnum.ReceivedInFull
                )
            }
            if (this.values.displayWithNotReceivedItems) {
                purchaseOrderState.push(
                    PurchaseOrderStateEnum.NotReceived
                )
            }

            this.criteria.PurchaseOrderStateEnumList_Tbl = purchaseOrderState;
        }
    }
}